import { forwardRef, Ref } from "react";
import styles from "./VideoSideLayout.module.css";

const SideVideoWrapper = forwardRef<HTMLDivElement, {}>(function SideVideoWrapper(_, ref) {
	return <div className={styles.sideVideo} ref={ref} />;
});

export default function VideoSideLayout({
	mainVideoRef,
	sideVideoRefs,
}: {
	mainVideoRef: Ref<HTMLDivElement>;
	sideVideoRefs: Ref<HTMLDivElement>[];
}) {
	return (
		<div className={styles.sideLayout}>
			<div className={styles.mainPanel} ref={mainVideoRef} />
			{sideVideoRefs.length > 1 ? (
				<div className={styles.sidePanel}>
					{sideVideoRefs.map((ref, index) => (
						<SideVideoWrapper key={index} ref={ref} />
					))}
				</div>
			) : (
				<div className={styles.mainPanel} ref={sideVideoRefs[0]} />
			)}
		</div>
	);
}
